import React, { useRef } from "react";
import { Formik } from "formik";
import Form from "./components/Form";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import Spin from "../../common/Spin";
import { API, fileUpload } from "../../../config";
import { toast } from "react-toastify";
import { AddSuburbsSchema } from "../../common/Validation";
import { useStateList } from "./components/SuburbsHelper";

const AddSuburbs = ({ toggleSuburbsModal, showSuburbs }) => {
  const [loading, setLoading] = useState(false);
  const [suburbsData, setSuburbsData] = useState();
  const formValues = useRef();
  let existingValues = [];
  let overwrittenFields = [];

  const handleFormSubmit = async (value) => {
    const formData = new FormData();
    value.state_id = value?.state_id?.value;
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("name", value?.name ? value?.name : "");
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.GET_ADMIN_SUBURB_LIST}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        toggleSuburbsModal();
      }
      return data?.data;
    } catch (error) {
      setSuburbsData(value);
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) => item?.value === suburbsData?.state_id
  );

  return (
    <>
      <Modal
        show={showSuburbs}
        onHide={toggleSuburbsModal}
        dialogClassName="small-review extra-small-popup"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          New Suburb
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              state_id: suburbsData?.state_id && state,
              name: suburbsData?.name ? suburbsData?.name : "",
            }}
            enableReinitialize
            innerRef={formValues}
            onSubmit={handleFormSubmit}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={AddSuburbsSchema}
          >
            {({
              values,
              setErrors,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <>
                  {loading && <Spin />}
                  <Form
                    values={values}
                    errors={errors}
                    setErrors={setErrors}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    formValues={formValues}
                    overwrittenFields={overwrittenFields}
                    existingValues={existingValues}
                    toggleSuburbsModal={toggleSuburbsModal}
                    stateLoading={stateLoading}
                    stateListing={stateListing}
                  />
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddSuburbs;
